import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Portlet from '../../common/components/Portlet';
import PaginatedTable from '../../common/components/Table/PaginatedTable';

import { fetchEvents, createEvent } from '../../redux/actions';

const ITEMS_PER_PAGE = 10;

export const mapStateToProps = state => ({
  events: state.eventsReducer.events,
  isFetching: state.eventsReducer.isFetching,
  totalCount: state.eventsReducer.totalCount,
  offset: state.eventsReducer.offset,
  limit: state.eventsReducer.limit,
  isMarkingForDeletionSuccess: state.eventsReducer.isMarkingForDeletionSuccess,
});

export const mapDispatchToProps = {
  fetchEvents,
  createEvent,
};

export const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  currentPage: (stateProps.offset / stateProps.limit) + 1,

  onTableChange(pagination, _, sorter) {
    const pageZeroBased = pagination.current - 1;
    const { order, field } = sorter;

    const sortProps = order
      ? {
        orderBy: field,
        sort: order === 'descend' ? 'desc' : 'asc',
      }
      : {};

    dispatchProps.fetchEvents({
      limit: ITEMS_PER_PAGE,
      offset: pageZeroBased * ITEMS_PER_PAGE,
      ...sortProps,
    });
  },
});

const portletConfig = {
  title: 'EVENT LIST',
};

const columns = [
  {
    title: 'Event Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    defaultSortOrder: 'ascend',
  },
  {
    title: 'Points',
    dataIndex: 'points',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    sorter: (a, b) => a.status.localeCompare(b.status),
  },
  {
    render: (_, record) => (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <Link
        to={`/event/${record.event_id}`}
        className="btn-link text-primary bg-transparent text-uppercase"
      >
        view/edit
      </Link>
    ),
  },
];

export const Events = (props) => {
  useEffect(() => {
    props.fetchEvents({
      limit: ITEMS_PER_PAGE,
      offset: 0,
      orderBy: 'name',
      sort: 'asc',
      markedForDeletion: false,
    });
  }, []);

  return (
    <div className="row">
      <div className="col-lg-12 col-xl-12 order-lg-1 order-xl-1">
        <Portlet config={portletConfig}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            to={{ pathname: '/events/create' }}
            className="action-btn"
          >
            <button className="btn btn-secondary">
              Add Event
            </button>
          </Link>
          <PaginatedTable
            columns={columns}
            dataSource={props.events}
            rowKey={record => record.event_id}
            loading={props.isFetching}
            limit={ITEMS_PER_PAGE}
            currentPage={props.currentPage}
            totalCount={props.totalCount}
            // getPage is not needed. onColumnChange is enough. It's triggered when pagination or sorting is changed.
            // It should be fixed in PaginatedTable.jsx
            getPage={() => {}}
            onColumnChange={props.onTableChange}
          />
        </Portlet>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Events);



// WEBPACK FOOTER //
// ./src/js/views/events/Events.jsx